import React from 'react';
import { TrendingDown, UserX, BarChart3, Crosshair } from 'lucide-react';

const challenges = [
  { icon: TrendingDown, text: 'Unsold inventory impacting cash flow' },
  { icon: UserX, text: 'Low-quality leads with no real intent' },
  { icon: BarChart3, text: 'Poor site visit to booking conversion' },
  { icon: Crosshair, text: 'Lack of structured sales execution' },
];

const Challenges = () => (
  <section className="bg-[#0f0f0f] py-24 sm:py-32" data-testid="challenges-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="max-w-3xl mx-auto text-center mb-20">
        <h2
          className="scroll-reveal text-3xl sm:text-4xl lg:text-[2.75rem] font-bold text-white leading-tight tracking-tight mb-6"
          data-testid="challenges-heading"
        >
          Built Around Real Builder Challenges
        </h2>
        <p className="scroll-reveal text-lg text-gray-400 font-light leading-relaxed" data-testid="challenges-subheading">
          We understand where projects get stuck — and how to move them forward.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto">
        {challenges.map(({ icon: Icon, text }, i) => (
          <div
            key={i}
            className={`scroll-reveal stagger-${i + 1} group flex items-start gap-5 rounded-2xl border border-white/[0.05] bg-white/[0.02] px-8 py-7 transition-all duration-300 hover:bg-white/[0.04] hover:border-white/[0.10]`}
            data-testid={`challenge-card-${i}`}
          >
            <div className="mt-0.5 flex-shrink-0 w-10 h-10 rounded-lg bg-white/[0.06] flex items-center justify-center text-gray-400 group-hover:text-white transition-colors duration-300">
              <Icon className="w-5 h-5" strokeWidth={1.5} />
            </div>
            <span className="text-[15px] sm:text-base text-gray-300 leading-relaxed font-light">{text}</span>
          </div>
        ))}
      </div>

      <p
        className="scroll-reveal text-center text-base text-gray-500 font-light mt-16 max-w-2xl mx-auto leading-relaxed"
        data-testid="challenges-closing"
      >
        Nova Homes addresses these challenges with a focused, execution-driven approach.
      </p>
    </div>
  </section>
);

export default Challenges;
